import { ContactDetailsPersistentModel } from '@shared/models/contact-details-persistent-model';
import { MultiFieldContent } from '@shared/models/multi-field-content';

export class PersistentOrder {
	placementCategoryId?: string;
	placementId?: string;
	packageId?: string;
	issueDates?: string[];
	styleId?: string;
	adText?: string;
	multiFieldContents?: MultiFieldContent[];
	contactDetails?: ContactDetailsPersistentModel;
	subscriberNumber?: string;
}
